var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content basicsSetting"},[[_c('el-tabs',[_vm._l((_vm.tabData),function(item,index){return [_c('el-tab-pane',{key:index,attrs:{"label":item}},[_c('div',{staticClass:"header"},[_vm._v(" 模块设置 ")]),_c('keep-alive',{attrs:{"max":10}},[_c(_vm.componentArr[index],{tag:"component"})],1)],1)]})],2)]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }